export default "__VITE_ASSET__BsdF9kDR__"